import React from 'react';

interface IProps extends React.PropsWithChildren<any>{
  isAllowed: ()=> void;
}
export const RuleProtected = React.memo(({ isAllowed, children, }: IProps) => !isAllowed ? <>Unauhotirzed!</> : children);
